import "./style.css"
import { Container, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/auth';
import { useOrgContext } from "../../context/org";
import { FaUserCircle } from "react-icons/fa";
import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";

function DashboardHeader() {
  return (
    <CollapsibleExample/>
  )
}

function CollapsibleExample() {

	const {logoutUser, user} = useAuth();
	const {org, orgs} = useOrgContext();

 	 const baseURL = process.env.REACT_APP_API_URL as string;
	const profileImg = user?.profileImg //"/images/atali.webp";
  
	return (
		<Navbar collapseOnSelect expand="lg" data-bs-theme="dark" className='main-nav'>
		<Container fluid>
			<Navbar.Brand as={Link} to="/dashboard">
				<Image fluid
				src='/images/chat-icon.svg' 
				style={{width:'30px', height:'30px', marginRight:'4px'}}/>
				QuickyChat
			</Navbar.Brand>
			<Navbar.Toggle aria-controls="responsive-navbar-nav" />
			<Navbar.Collapse id="responsive-navbar-nav">
				<Nav className="me-auto">
					
				</Nav>
			<Nav>
				{org ?
				<NavDropdown title="Organization" style={{zIndex: 1025}}>
					<NavDropdown.Item as={Link} to="/dashboard/">Dashboard</NavDropdown.Item>
					<NavDropdown.Item as={Link} to={`/dashboard/orgs/${org.id}/settings`}>Settings</NavDropdown.Item>
					<NavDropdown.Item as={Link} to={`/dashboard/orgs/${org.id}/plans`}>Subscription</NavDropdown.Item>
					{orgs !== undefined && orgs.length > 1 && 
					<NavDropdown.Item as={Link} to={'/dashboard/orgs'}>Organizations</NavDropdown.Item>
					}
				</NavDropdown> :
				<Nav.Link as={Link} to="/dashboard/">Organizations</Nav.Link>
				}
				<NavDropdown
					align="end"
					title={
						profileImg ? (
							<Image
							src={`${profileImg}`}
							roundedCircle
							height="30"
							width="30"
							alt="User Avatar"
							/>
						) : (
							<FaUserCircle size={30} />
						)
					}
					style={{zIndex: 1025}}
					id="user-avatar-dropdown">
				
					<NavDropdown.Item as={Link} to="/dashboard/account">Account Settings</NavDropdown.Item>
					<NavDropdown.Item as={Link} to="/dashboard/support">Support</NavDropdown.Item>
					<NavDropdown.Divider />
					<NavDropdown.Item onClick={() => logoutUser()}>Logout</NavDropdown.Item>
				</NavDropdown>
				{/* <Nav.Link onClick={()=>logout()}>
					Logout
				</Nav.Link> */}
			</Nav>
			</Navbar.Collapse>
		</Container>
		</Navbar>
	);
}

export default DashboardHeader;